import localStorageService from './localStorageService';

const CHAT_STATE_KEY = 'state';

export const getChatState = (): 'open' | 'closed' => {
  const chatStateInStorage = localStorageService.get(CHAT_STATE_KEY);

  return chatStateInStorage !== 'open' && chatStateInStorage !== 'closed'
    ? 'open'
    : chatStateInStorage;
};

export const setChatState = (chatState: 'open' | 'closed') =>
  localStorageService.set(CHAT_STATE_KEY, chatState);
